export class ApiStatusError extends Error {
  readonly status: string | undefined

  readonly url: string

  readonly data: unknown // raw body; a service subclasses this to expose its endpoint's extra fields

  constructor({
    url,
    status,
    message,
    data
  }: {
    url: string
    status?: string
    message: string
    data: unknown
  }) {
    super(message)
    this.name = "ApiStatusError"
    this.url = url
    this.status = status
    this.data = data
  }
}

export default ApiStatusError
